var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.total > 0)?_c('el-pagination',{staticClass:"block",attrs:{"background":"","total":_vm.total,"page-size":_vm.pagination.limit,"page-count":_vm.pagination.totalPage,"current-page":_vm.pagination.currentPage},on:{"current-change":_vm.pageChanged,"prev-click":_vm.pageChanged,"next-click":_vm.pageChanged}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }